import client from './client';
import { ProductComment } from '../types';

export const getProductComments = async (
  productId: string,
): Promise<ProductComment[]> => {
  const response = await client.get(`product-comments/product/${productId}`);
  return response.data;
};

export const createProductComment = async (
  productId: string,
  payload: { authorName: string; content: string; parentId?: string },
): Promise<ProductComment> => {
  const response = await client.post(
    `product-comments/product/${productId}`,
    payload,
  );
  return response.data;
};

export const updateProductComment = async (
  commentId: string,
  payload: { content: string },
): Promise<ProductComment> => {
  const response = await client.patch(`product-comments/${commentId}`, payload);
  return response.data;
};

export const deleteProductComment = async (commentId: string) => {
  const response = await client.delete(`product-comments/${commentId}`);
  return response.data;
};

export const getAdminProductComments = async (
  productId: string,
): Promise<ProductComment[]> => {
  const response = await client.get(`product-comments/admin/product/${productId}`);
  return response.data;
};

export const createAdminProductComment = async (
  productId: string,
  payload: { authorName: string; content: string; parentId?: string },
): Promise<ProductComment> => {
  const response = await client.post(
    `product-comments/admin/product/${productId}`,
    payload,
  );
  return response.data;
};

export const updateAdminProductComment = async (
  commentId: string,
  payload: { authorName: string; content: string },
): Promise<ProductComment> => {
  const response = await client.patch(
    `product-comments/admin/${commentId}`,
    payload,
  );
  return response.data;
};

export const deleteAdminProductComment = async (commentId: string) => {
  const response = await client.delete(`product-comments/admin/${commentId}`);
  return response.data;
};
